import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

    constructor(private spinner: NgxSpinnerService,private router: Router) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        {

            if(req.url.indexOf('/v1/api/check-user-availability') !== -1 ||
                req.url.indexOf('/v1/api/order-check') !== -1 || 
                req.url.indexOf('/notification/all') !== -1 ||
                req.url.indexOf('/v1/api/rcd/') !== -1){
                
            }else{
                this.spinner.show();
            }
           
            if (req.url.indexOf('/v1/login') == -1) {
                let token = localStorage.getItem('token');
                let modifierReq = req.clone({ headers: req.headers.append('Authorization', 'Bearer ' + token) })

                return next.handle(modifierReq).do((event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                        setTimeout(()=>{
                            this.spinner.hide();    
                        },800)
                        
                    }
                }, (err: any) => {
                    if (err instanceof HttpErrorResponse) {
                        setTimeout(()=>{
                            this.spinner.hide();    
                        },800)
                    }
                });
        } else {
            console.log("in ekserreee")
            return next.handle(req);
        }
    }
}
}